export class ShowItemSimilarService {
    constructor(httpClient) {
      this.httpClient = httpClient
    }
  
    async handle(params) {
      return await this.httpClient.get('/itens/Similares', { params })
    }
  }
  